import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { FormBuilder,UntypedFormControl, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { InventoryService } from '../../services/inventory.service'
import { PrintService } from '../../services/print.service'
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DropzoneComponent, DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-special-pricing',
	templateUrl: './special-pricing.component.html',
	styleUrls: ['./special-pricing.component.scss']
})
export class SpecialPricingComponent implements OnInit {
	@ViewChild('specEdit') specEditRef: ElementRef;
	@ViewChild('specUp') specUpload: ElementRef;


	searchSpecials = new UntypedFormControl('');
	blanket = new UntypedFormControl('');
	/** Sentinel for items with no brand in multi-select. */
	readonly brandNoneKey = '__NO_BRAND__';
	brandOptions: string[] = [];
	filterForm: FormGroup;
	allinactive: any[] = [];
	itemdetails: any = false;
	imsearch: any= false;
	color = 'blue';
	active: any = [];
	inactive: any = [];
	stockid: any = null;
	pricelvs: any = [];
	prices_array: any = [];
	original_prices_array: any = [];
	defaulttype: any = '2';
	allitems: any = [];
	filteredOptions: any = [];
	files: any = [];
	uploaddata: any = [];
	specialForm: FormGroup;
	/** Logical upload targets (field key → label). Price_* rows come from pricelvs. */
	mapcols: { field: string; label: string }[] = [];
	/** For each logical field, which file column (header key) supplies it — inverted to server `mapping` on submit. */
	uploadSourceByField: Record<string, string> = {};
	selectedItem: any = false;
	editing = false;
	allactive: any[] = [];
	config: any = false;

	
	constructor(public printService: PrintService, private fb: FormBuilder, private inventoryService: InventoryService, private globalSearchService: GlobalSearchService, private location: Location, public cdr: ChangeDetectorRef, private modalService: NgbModal, private datePipe: DatePipe) {
		this.color = this.globalSearchService.getColor();
		this.filterForm = this.fb.group({
			brands: [[] as string[]],
			ageMin: [''],
			ageMax: [''],
			qohMin: [''],
			qohMax: [''],
		});
	}

	ngOnInit(): void {

		this.globalSearchService.configsubscription.subscribe((res) => {
			this.config = res;
		})

		this.globalSearchService.all_system_types.subscribe((alltypes: any) => {
			if (alltypes?.salestypes) {
				this.pricelvs = alltypes.salestypes;
				this.rebuildUploadMapcols();
			}
		});

		this.blanket.valueChanges.subscribe( newValue => {
			if(this.prices_array.length) {
				this.prices_array.forEach(p => {
					p.price = newValue;
				})
			}
		});

		this.filterForm.valueChanges.subscribe(() => this.applyFilters());

		this.rebuildUploadMapcols();
	}

	selectItem(stockid: any) {
		this.inventoryService.loadItem(stockid).subscribe((results: any) => {
			this.itemdetails = results;
		});
	}


	itemSearch(): void {
		this.applyFilters();
	}

	private brandKey(row: any): string {
		const b = (row?.brand ?? '').toString().trim();
		return b === '' ? this.brandNoneKey : b;
	}

	brandLabel(key: string): string {
		return key === this.brandNoneKey ? '(No brand)' : key;
	}

	rebuildBrandOptions(): void {
		const set = new Set<string>();
		for (const r of this.allactive || []) {
			set.add(this.brandKey(r));
		}
		for (const r of this.allinactive || []) {
			set.add(this.brandKey(r));
		}
		this.brandOptions = Array.from(set).sort((a, b) => {
			if (a === this.brandNoneKey) {
				return 1;
			}
			if (b === this.brandNoneKey) {
				return -1;
			}
			return a.localeCompare(b, undefined, { sensitivity: 'base' });
		});
	}

	selectAllBrands(): void {
		this.filterForm.patchValue({ brands: [...this.brandOptions] }, { emitEvent: true });
	}

	selectNoBrands(): void {
		this.filterForm.patchValue({ brands: [] }, { emitEvent: true });
	}

	clearRangeFilters(): void {
		this.filterForm.patchValue(
			{ ageMin: '', ageMax: '', qohMin: '', qohMax: '' },
			{ emitEvent: true }
		);
	}

	private parseFilterNum(v: any): number | null {
		if (v === '' || v === null || v === undefined) {
			return null;
		}
		const n = Number(v);
		return Number.isFinite(n) ? n : null;
	}

	private filterRows(source: any[]): any[] {
		let rows = [...(source || [])];
		const term = (this.searchSpecials.value ?? '').toString().trim();
		if (term) {
			rows = this.globalSearchService.filterItem(
				rows,
				term,
				'stockid,description,brand,rawsize,mfgpart,categoryid,lineid'
			);
		}
		const brands = this.filterForm.get('brands')?.value as string[] | undefined;
		if (brands?.length) {
			const set = new Set(brands);
			rows = rows.filter((r) => set.has(this.brandKey(r)));
		}
		const ageMin = this.parseFilterNum(this.filterForm.get('ageMin')?.value);
		const ageMax = this.parseFilterNum(this.filterForm.get('ageMax')?.value);
		const qohMin = this.parseFilterNum(this.filterForm.get('qohMin')?.value);
		const qohMax = this.parseFilterNum(this.filterForm.get('qohMax')?.value);
		rows = rows.filter((r) => {
			const age = Number(r?.age);
			const qoh = Number(r?.qoh);
			if (ageMin !== null) {
				if (Number.isNaN(age) || age < ageMin) {
					return false;
				}
			}
			if (ageMax !== null) {
				if (Number.isNaN(age) || age > ageMax) {
					return false;
				}
			}
			if (qohMin !== null) {
				if (Number.isNaN(qoh) || qoh < qohMin) {
					return false;
				}
			}
			if (qohMax !== null) {
				if (Number.isNaN(qoh) || qoh > qohMax) {
					return false;
				}
			}
			return true;
		});
		return rows;
	}

	applyFilters(): void {
		this.active = this.filterRows(this.allactive);
		this.inactive = this.filterRows(this.allinactive);
	}

	addSpecial() {
		this.itemdetails = false;
		this.editing = false;
		this.prices_array = [];
		this.pricelvs.forEach(x => this.addList(x, 0));

		this.specialForm = this.fb.group({
			specialid: [''],
			stockid: ['', Validators.required],
			startdate: ['', Validators.required],
			enddate: ['', Validators.required],
			qtylimit: [0, Validators.required],
			qtysold: [0],
			andor: [this.defaulttype],
			clearsold: [0],
			nfd: [false],
		});

		this.setValiditiy();

		this.autocompleteFilter();
		this.modalService.open(this.specEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.itemdetails = false;
		});
	}

	autocompleteFilter() {

		if(this.imsearch) {
			this.imsearch.unsubscribe()
		}

		const data = {
			stockid: this.specialForm.get('stockid').value
		};

		this.imsearch = this.inventoryService.itemSearch(data).subscribe(results => {

			const no_zero = results.filter( r => {
				return parseFloat(r.qty) > 0
			})
			this.allitems = no_zero;
			this.filteredOptions = no_zero;
		});

	}
	setValiditiy() {

		switch(this.specialForm.get('andor').value) {
		case '1':
			this.specialForm.get('startdate').setValidators([Validators.required])
			this.specialForm.get('startdate').updateValueAndValidity();

			this.specialForm.get('enddate').setValidators([Validators.required])
			this.specialForm.get('enddate').updateValueAndValidity();

			break;
		default:
			this.specialForm.get('startdate').setValidators([])
			this.specialForm.get('startdate').updateValueAndValidity();

			this.specialForm.get('enddate').setValidators([])
			this.specialForm.get('enddate').updateValueAndValidity();
			break;
		}
	}
	addList(x: any, y: any) {

		if (!y) {
			y = 0;
		}

		const price = {
			typeabbrev: x.typeabbrev,
			sales_type: x.sales_type,
			price: y,
		}

		this.prices_array.push(price);

	}

	setForm() {

	}

	validate() {
		let proc = true;

		if(this.specialForm.get('andor').value == '2') {
			if(parseFloat(this.specialForm.get('qtylimit').value) > 0 ) {

			} else {
				alert('Qty Can not be zero while using QTY');
				proc = false;
			}
		}

		return proc;
	}

	private buildSpecialsExportRows(): Record<string, string | number>[] {

		let tires = false;
		if(this.config.env.package == 'tires'){
			tires = true;
		}

		const rows: Record<string, string | number>[] = [];
		for (const p of this.active || []) {
			let row :Record<string,string | number>;
			if(tires){
				row = {
					'Stock ID': p.stockid ?? '',
					'Raw Size': p.rawsize ?? '',
					Brand: p.brand ?? '',
					'Mfg Part': p.mfgpart ?? '',
					Category: p.categoryid ?? '',
					'Product Line': p.lineid ?? '',
					Description: p.description ?? '',
					'Start Date': this.datePipe.transform(p.startdate, 'shortDate') ?? '',
					'End Date': this.datePipe.transform(p.enddate, 'shortDate') ?? '',
					Remaining: p.qtyleft ?? '',
					QOH: p.qoh ?? '',
					Age: p.age ?? '',
				};
			}else{
				row = {
					'Stock ID': p.stockid ?? '',
					Brand: p.brand ?? '',
					Manufacturer: p.manufacturer ?? '',
					'Brand code': p.mfgpart_brand ?? '',
					'Mfg Part': p.mfgpart ?? '',
					Category: p.categoryid ?? '',
					'Product Line': p.lineid ?? '',
					Description: p.description ?? '',
					'Start Date': this.datePipe.transform(p.startdate, 'shortDate') ?? '',
					'End Date': this.datePipe.transform(p.enddate, 'shortDate') ?? '',
					Remaining: p.qtyleft ?? '',
					QOH: p.qoh ?? '',
					Age: p.age ?? '',
				};
			}
			for (const lv of this.pricelvs || []) {
				const ta = lv?.typeabbrev;
				const label = lv?.sales_type || ta;
				if (!label) {
					continue;
				}
				const raw = ta && p.prices ? p.prices[ta] : null;
				row[label] = raw != null && raw !== '' ? Number(raw) : '';
			}
			rows.push(row);
		}
		return rows;
	}

	private escPdf(v: any): string {
		if (v === null || v === undefined) {
			return '';
		}
		return String(v)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	private buildSpecialsExportHtml(): string {
		
		let tires = false;
		if(this.config.env.package == 'tires'){
			tires = true;
		}


		let html = '<table class="table table-sm table-bordered"><thead><tr>';
		html += '<th>Stock ID</th><th>Raw Size</th><th>Brand</th>';
		
		if(!tires){
			html += '<th>Manufacturer</th><th>Brand code</th>'
		}

		html += '<th>Mfg Part</th><th>Category</th><th>Product Line</th>'		
		html += '<th>Description</th><th>Start Date</th><th>End Date</th><th>Remaining</th><th>QOH</th><th>Age</th>';
		for (const lv of this.pricelvs || []) {
			if (lv?.sales_type) {
				html += `<th>${this.escPdf(lv.sales_type)}</th>`;
			}
		}
		html += '</tr></thead><tbody>';
		for (const p of this.active || []) {
			html += '<tr>';
			html += `<td class="text-left">${this.escPdf(p.stockid)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.rawsize)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.brand)}</td>`;
			if(!tires){
				html += `<td class="text-left">${this.escPdf(p.manufacturer)}</td>`;
				html += `<td class="text-left">${this.escPdf(p.mfgpart_brand)}</td>`;
			}	
			html += `<td class="text-left">${this.escPdf(p.mfgpart)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.categoryid)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.lineid)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.description)}</td>`;
			html += `<td class="text-center">${this.escPdf(this.datePipe.transform(p.startdate, 'shortDate'))}</td>`;
			html += `<td class="text-center">${this.escPdf(this.datePipe.transform(p.enddate, 'shortDate'))}</td>`;
			html += `<td class="text-center">${this.escPdf(p.qtyleft)}</td>`;
			html += `<td class="text-center">${this.escPdf(p.qoh)}</td>`;
			html += `<td class="text-center">${this.escPdf(p.age)}</td>`;
			for (const lv of this.pricelvs || []) {
				const ta = lv?.typeabbrev;
				const raw = ta && p.prices ? p.prices[ta] : null;
				const disp = raw != null && raw !== '' ? Number(raw).toFixed(2) : '';
				html += `<td class="text-right">${this.escPdf(disp)}</td>`;
			}
			html += '</tr>';
		}
		html += '</tbody></table>';
		return html;
	}

	exportSpecialsXlsx(): void {
		const rows = this.buildSpecialsExportRows();
		if (!rows.length) {
			return;
		}
		const stamp = new Date().toISOString().slice(0, 10);
		this.globalSearchService.exportJsonToExcel(rows, `Specials_${stamp}.xlsx`);
	}

	exportSpecialsPdf(): void {
		if (!this.active?.length) {
			return;
		}
		const stamp = new Date().toISOString().slice(0, 10);
		const content = this.globalSearchService.base64encode(this.buildSpecialsExportHtml());
		const data = {
			content,
			filename: `Specials_${stamp}.pdf`,
			title: 'Item Specials',
			subtitle: `Exported ${new Date().toLocaleString()} · ${this.active.length} row(s)`,
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	editSpecial(spec: any) {
		this.editing = true;
		this.prices_array = [];
		this.inventoryService.getItemSpecial(spec).subscribe((results: any) => {
			this.selectItem(results.stockid);

			this.pricelvs.forEach(x => this.addList(x, results.prices[x.typeabbrev]));

			this.specialForm = this.fb.group({
				specialid: [results.specialid],
				stockid: [results.stockid, Validators.required],
				startdate: [results.startdate, Validators.required],
				enddate: [results.enddate, Validators.required],
				qtylimit: [results.qtylimit, Validators.required],
				qtysold: [results.qtysold],
				clearsold: [0],
				andor: [results.andor],
				nfd: [results.nfd],
			});
			this.setValiditiy();
			this.autocompleteFilter();
			//this.original_prices_array = results.prices;
			this.modalService.open(this.specEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}

	specialByStockID() {


		const data = { stockid: this.specialForm.get('stockid').value };
		this.inventoryService.getStockItemSpecial(data).subscribe((results: any) => {
			if (results) {
				this.prices_array = [];

				this.pricelvs.forEach(x => this.addList(x, results.prices[x.typeabbrev]));

				this.specialForm = this.fb.group({
					specialid: [results.specialid],
					stockid: [results.stockid, Validators.required],
					startdate: [results.startdate, Validators.required],
					enddate: [results.enddate, Validators.required],
					qtylimit: [results.qtylimit, Validators.required],
					qtysold: [results.qtysold],
					clearsold: [0],
					andor: ['2'],
					nfd: [false],
				});
				this.setValiditiy();
			}
		});

	}
	saveSpecial() {

		//let data = this.specialForm.value;
		if(this.specialForm.valid && this.validate()) {
			const data = {
				specialid: this.specialForm.get('specialid').value,
				stockid: this.specialForm.get('stockid').value,
				startdate: this.specialForm.get('startdate').value,
				enddate: this.specialForm.get('enddate').value,
				qtylimit: this.specialForm.get('qtylimit').value,
				clearsold: this.specialForm.get('clearsold').value,
				andor: this.specialForm.get('andor').value,
				prices: this.prices_array,
				nfd: this.specialForm.get('nfd').value,
			};

			this.inventoryService.saveItemSpecial(data).subscribe((results: any) => {
				this.editing = false;
				this.allactive = results.active;
				this.allinactive = results.inactive;
				this.rebuildBrandOptions();
				this.applyFilters();
				this.modalService.dismissAll();
			});
		}
	}

	removeSpecial(data: any) {
		this.inventoryService.removeItemSpecial(data).subscribe((results: any) => {
			this.allactive = results.active;
			this.allinactive = results.inactive;
			this.rebuildBrandOptions();
			this.applyFilters();
			this.modalService.dismissAll();
		});
	}

	uploadSpecial() {
		this.resetSpecialUploadState();
		this.modalService.open(this.specUpload, { ariaLabelledBy: 'modal-title', size: 'xl', scrollable: true }).result.then((result) => {

		}, (reason) => {

		});
	}

	private resetSpecialUploadState(): void {
		this.files = [];
		this.uploaddata = [];
		this.uploadSourceByField = {};
	}

	private rebuildUploadMapcols(): void {
		const base: { field: string; label: string }[] = [
			{ field: 'stockid', label: 'Item number' },
			{ field: 'startdate', label: 'Start date' },
			{ field: 'enddate', label: 'End date' },
			{ field: 'limit', label: 'Qty limit' },
			{ field: 'baseprice', label: 'Blanket price (all price types)' },
			{ field: 'andor', label: 'Special type (date-based vs qty-based)' },
			{ field: 'qoh', label: 'Use QOH when limit is 0 (optional)' },
		];
		const priceCols = (this.pricelvs || []).map((lv: any) => ({
			field: 'price_' + lv.typeabbrev,
			label: (lv.sales_type || lv.typeabbrev || 'Price') + ' (' + lv.typeabbrev + ')',
		}));
		this.mapcols = [...base, ...priceCols];
	}

	/** Match PHP `ModelWeberpUpload::cleanName` so we can align headers to export / temp table keys. */
	private normalizeHeaderKey(name: string): string {
		return (name || '')
			.toLowerCase()
			.replace(/\./g, '')
			.replace(/-/g, '')
			.replace(/\s+/g, '')
			.replace(/'/g, '')
			.replace(/[()]/g, '');
	}

	private applyUploadColumnGuesses(): void {
		const headers: string[] = this.uploaddata?.header || [];
		if (!headers.length) {
			return;
		}
		this.uploadSourceByField = {};
		const used = new Set<string>();
		const tryField = (field: string, matcher: (h: string, norm: string) => boolean) => {
			if (this.uploadSourceByField[field]) {
				return;
			}
			for (const h of headers) {
				if (used.has(h)) {
					continue;
				}
				const norm = this.normalizeHeaderKey(h);
				if (matcher(h, norm)) {
					this.uploadSourceByField[field] = h;
					used.add(h);
					return;
				}
			}
		};

		tryField('stockid', (_h, n) => n === 'stockid' || n === 'itemnumber' || n === 'sku' || n === 'itemno');
		tryField('startdate', (_h, n) => n === 'startdate' || n.startsWith('start'));
		tryField('enddate', (_h, n) => n === 'enddate' || n.startsWith('end'));
		tryField('limit', (_h, n) => n === 'remaining' || n === 'qtylimit' || n === 'limit' || n === 'qtyleft');
		tryField('baseprice', (_h, n) => n === 'baseprice' || n === 'blanketprice' || n === 'specialprice');
		tryField('andor', (_h, n) => n === 'andor' || n === 'specialtype');
		tryField('qoh', (_h, n) => n === 'qoh');

		for (const lv of this.pricelvs || []) {
			const ta = (lv?.typeabbrev || '').toString();
			const field = 'price_' + ta;
			if (!ta) {
				continue;
			}
			const labelNorm = this.normalizeHeaderKey((lv.sales_type || '').toString());
			tryField(field, (_h, n) => n === ta.toLowerCase() || (labelNorm !== '' && n === labelNorm));
		}
	}

	onUploadSourceChange(field: string, col: string): void {
		const next = col || '';
		if (next) {
			for (const mc of this.mapcols) {
				if (mc.field !== field && this.uploadSourceByField[mc.field] === next) {
					delete this.uploadSourceByField[mc.field];
				}
			}
		}
		if (next) {
			this.uploadSourceByField[field] = next;
		} else {
			delete this.uploadSourceByField[field];
		}
	}

	get uploadMappedPreviewHeaders(): string[] {
		const ordered: string[] = [];
		const seen = new Set<string>();
		for (const mc of this.mapcols) {
			const h = this.uploadSourceByField[mc.field];
			if (h && !seen.has(h)) {
				seen.add(h);
				ordered.push(h);
			}
		}
		return ordered;
	}

	get uploadPreviewRows(): any[] {
		const rows = this.uploaddata?.rows || [];
		return rows.slice(0, 10);
	}

	private buildServerColumnMapping(): Record<string, string> {
		const out: Record<string, string> = {};
		for (const mc of this.mapcols) {
			const col = this.uploadSourceByField[mc.field];
			if (col) {
				out[col] = mc.field;
			}
		}
		return out;
	}

	private validateUploadBeforeSend(mapping: Record<string, string>): string | null {
		if (!this.uploaddata?.rows?.length) {
			return 'No rows to import.';
		}
		const flipped: Record<string, string> = {};
		for (const k of Object.keys(mapping)) {
			flipped[mapping[k]] = k;
		}
		if (!flipped.stockid) {
			return 'Choose which file column is the item number (Stock ID / SKU).';
		}
		return null;
	}

	sendSpecials() {
		const mapping = this.buildServerColumnMapping();
		const err = this.validateUploadBeforeSend(mapping);
		if (err) {
			alert(err);
			return;
		}
		const data = { tabledata: this.uploaddata, mapping };
		this.inventoryService.sendItemSpecials(data).subscribe((results: any) => {
			this.allactive = results.active;
			this.allinactive = results.inactive;
			this.rebuildBrandOptions();
			this.applyFilters();
			this.modalService.dismissAll();
		});
	}
	onUploadError(event: any) {

	}

	onUploadSuccess(event: any) {

	}

	onRemove(_f: File): void {
		this.files = [];
	}

	onSelect(event: any) {
		this.files.push(...event.addedFiles);
		for (let i = 0; i < this.files.length; i++) {
			this.readFile(this.files[i]).then(fileContents => {
				const upload = {
					content: fileContents,
					name: event.addedFiles[0].name,
					mime: event.addedFiles[0].type,
				};

				this.inventoryService.uploadSpecials(upload).subscribe((results: any) => {
					this.uploaddata = results;
					this.applyUploadColumnGuesses();
					this.files = [];
				});

			});
		}
	}
	ngAfterViewInit() {
		this.inventoryService.getSpecialsData().subscribe((results: any) => {
			this.allactive = results.active || [];
			this.allinactive = results.inactive || [];
			this.defaulttype = results.defaulttype;
			this.rebuildBrandOptions();
			this.applyFilters();
		});
	}

	back(): void {
		this.location.back()
	}

	filterItem(input: any, term: any, keys: any) {
		const result = Object.assign([], input).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
		return result
	}

	private async readFile(file: File): Promise < string | ArrayBuffer > {
		return new Promise < string | ArrayBuffer > ((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});
	}
}
